// app/javascript/controllers/concerns/auto_scroll.js
export const AutoScroll = {
  initAutoScroll(scrollContainerId) {
    this.scrollInterval = null
    this.scrollDirection = null
    this.scrollRafId = null
    this.scrollContainer = document.getElementById(scrollContainerId)

    // イベントリスナーの設定
    this.scrollContainer.addEventListener('dragover', this.handleDragOver.bind(this))
    document.addEventListener('drop', this.clearScroll.bind(this))
    document.addEventListener('dragleave', this.clearScroll.bind(this))
  },

  disconnectAutoScroll() {
    this.scrollContainer?.removeEventListener('dragover', this.handleDragOver)
    document.removeEventListener('drop', this.clearScroll)
    document.removeEventListener('dragleave', this.clearScroll)
    this.clearScroll()
  },

  handleDragOver(event) {
    const margin = 50
    const { clientX } = event
    const rect = this.scrollContainer.getBoundingClientRect()

    if (clientX < rect.left + margin) {
      this.scrollDirection = 'left'
    } else if (clientX > rect.right - margin) {
      this.scrollDirection = 'right'
    } else {
      this.scrollDirection = null
    }

    if (!this.scrollRafId) {
      this.scrollLoop()
    }
  },

  scrollLoop() {
    const speed = 4

    if (this.scrollDirection === 'left') {
      this.scrollContainer.scrollLeft -= speed
    } else if (this.scrollDirection === 'right') {
      this.scrollContainer.scrollLeft += speed
    }

    if (this.scrollDirection) {
      this.scrollRafId = requestAnimationFrame(this.scrollLoop.bind(this))
    } else {
      this.scrollRafId = null
    }
  },

  clearScroll() {
    this.scrollDirection = null
    if (this.scrollRafId) {
      cancelAnimationFrame(this.scrollRafId)
      this.scrollRafId = null
    }
  }
}